import { MenuItem } from 'primeng/api';
import { BulkActionConfig } from '../bulk-action-dialog/bulk-action-dialog.component';

/**
 * Menu state and initialization logic extracted from HomeComponent.
 * Handles construction and management of all menu items.
 */
export class MenuStateLogic {
  /**
   * Initialize bulk action configurations
   */
  static initializeBulkActions(): BulkActionConfig[] {
    return [
      {
        id: 'export',
        label: 'Export Notes...',
        description: 'Export the selected notes to PDF, DOCX, or JSON.',
        requiresParams: true,
      },
      {
        id: 'print',
        label: 'Print',
        description: 'Print the selected notes as a PDF document.',
        requiresParams: false,
      },
      {
        id: 'set-status',
        label: 'Set status...',
        description: 'Update the status for all selected notes.',
        requiresParams: true,
      },
      {
        id: 'add-tags',
        label: 'Add Tags',
        description: 'Add one or more existing tags to all selected notes.',
        requiresParams: true,
      },
      {
        id: 'remove-tags',
        label: 'Remove tags...',
        description: 'Remove all tags or selected tags from the selected notes.',
        requiresParams: true,
      },
      {
        id: 'move-to-space',
        label: 'Move to Space...',
        description: 'Move the selected notes to another Space. They keep their modified dates and private tags; Space tags stay behind.',
        requiresParams: true,
      },
      {
        id: 'set-favorite',
        label: 'Set as favorite',
        description: 'Add the selected notes to your Favorites (their modified dates are not changed).',
        requiresParams: false,
      },
      {
        id: 'delete',
        label: 'Move to trash...',
        description: 'Move the selected notes to Trash. They can be restored from Trash for 30 days.',
        requiresParams: false,
      },
    ];
  }

  /**
   * Build menu items from bulk action configs
   */
  static buildBulkActionMenuItems(
    bulkActions: BulkActionConfig[],
    onActionSelected: (actionId: string) => void,
  ): MenuItem[] {
    return bulkActions.map((action) => ({
      label: action.label,
      command: () => onActionSelected(action.id),
    }));
  }
}
